import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const rideType = {
  namespaced: true,
  state: {
    rideTypes: []
  },
  getters,
  mutations,
  actions
}
